import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DEALER } from "@/data/dealer";
import { Reveal } from "@/components/motion/Reveal";
import { PromoGraphics, RatingBlock } from "@/components/site/Rating";

export const Reputation = () => (
  <section className="on-dark bg-charcoal py-16 text-white lg:py-28" aria-labelledby="reviews-heading" data-testid="reputation-section">
    <div className="container-x grid gap-12 lg:grid-cols-12 lg:gap-16">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow">Customer reviews</p>
        <h2 id="reviews-heading" className="mb-10 mt-4 font-display text-3xl font-extrabold leading-[1.04] tracking-tight sm:text-4xl lg:text-[2.75rem]">
          Rated by the people who bought from us.
        </h2>
        <RatingBlock dark />
        <ul className="mt-8 flex flex-wrap gap-2" aria-label="AutoTrader Highly Rated awards">
          {DEALER.awards.map((y) => (
            <li key={y} className="rounded-sm border border-white/20 px-3 py-1.5 text-sm font-semibold">
              Highly Rated {y}
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <a href={DEALER.autotrader.reviews} target="_blank" rel="noopener noreferrer" className="btn btn-primary" data-testid="reputation-autotrader-reviews-link">
            Read reviews on AutoTrader <ArrowUpRight aria-hidden="true" />
          </a>
          <Link to="/reviews" className="btn btn-outline-light" data-testid="reputation-reviews-page-link">
            About our reviews
          </Link>
        </div>
      </Reveal>
      <Reveal className="flex flex-col justify-center gap-4 lg:col-span-7" delay={0.12}>
        <PromoGraphics />
        <p className="text-sm leading-relaxed text-zinc-400">
          Promotional graphics supplied by YK Motors. Every customer review is published on AutoTrader — read them first-hand there.
        </p>
      </Reveal>
    </div>
  </section>
);
